import { Component, inject } from '@angular/core';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import { ParentItemProviderService } from '@app/shared/services/parent-item-provider.service';
import {
  ActionComponent,
  ItemInfo,
  ItemViewProviderDirective,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { catchError, finalize, first, switchMap, tap } from 'rxjs';

@Component({
  selector: `app-odabir-jedinice-za-dostavu`,
  templateUrl:
    '../../shared/components/odabir-jedinica-gradiva/odabir-jedinica.component.html',
  providers: [ParentItemProviderService]
})
export class OdabirJediniceZaDostavuComponent extends ActionComponent {
  public showDialog = false;

  private itemViewProvider = inject(ItemViewProviderDirective);
  private listviewProvider = inject(ListViewProviderDirective);
  private notificationService = inject(NotificationService);

  public onSelectedItem(jedinice: JedinicaGradiva[]) {
    this.itemViewProvider.item$
      .pipe(
        first(),
        switchMap((parent) => {
          return this.listviewProvider
            .executeAction('potvrdiDodavanjeJediniceZaDostavu', {
              $selected: jedinice,
              $parentId: new ItemInfo(parent).id
            })
            .pipe(
              tap(() => {
                const message =
                  jedinice.length > 1
                    ? 'Jedinice gradiva uspješno dodane'
                    : 'Jedinica gradiva uspješno dodana';
                this.notificationService.success(message);
                this.listviewProvider.refresh();
              }),
              catchError((e) => {
                const errorMessage =
                  jedinice.length > 1
                    ? 'Greška pri dodavanju jedinica gradiva'
                    : 'Greška pri dodavanju jedinice gradiva';
                this.notificationService.error(errorMessage);
                throw e;
              }),
              finalize(() => {
                this.showDialog = false;
              })
            );
        })
      )
      .subscribe();
  }

  override execute(): void {
    this.showDialog = true;
  }
}
